import { useEffect, useState } from 'react';
import { Box, Center, Column, Icon, Pressable, Text } from '~/commonComponents';
import { Colors } from '../../../themes/colors';
import ConfirmPopup from '../../shared/ConfirmPopup';
import { PaymentFailedPopup } from './PaymentFailedPopup';
import { PaymentSuccessPopup } from './PaymentSuccessPopup';
import { useSuspendedPostingsPopup } from './useSuspendedPostingsPopup';

const WarningIconComponent = () => (
  <Box marginBottom={12}>
    <Icon name="warning-outline" size={80} color={Colors.warning_500} />
  </Box>
);

export const SuspendedPostingsPopup = () => {
  const {
    isOpen,
    suspendedPostings,
    failedPostings,
    totalCount,
    isProcessing,
    paymentResultState,
    handlePayNow,
    handlePayLater,
    handleCloseSuccessPopup,
    handleRetryFromFailedPopup,
    handlePayLaterFromFailedPopup,
  } = useSuspendedPostingsPopup();

  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setShowAll(false);
    }
  }, [isOpen]);

  const hasMore = suspendedPostings.length > 3;
  const initialPostings = suspendedPostings.slice(0, 3);

  const renderDescription = () => {
    return (
      <Center
        style={{
          width: '80%',
          marginBottom: -32,
        }}
      >
        <Column>
          <Text color="neutral_500" fontSize={16} marginBottom={16}>
            These [{totalCount}] job postings are currently suspended:
          </Text>

          {!showAll ? (
            <>
              <Box gap={4} width={420}>
                {initialPostings.map((posting) => (
                  <Text
                    key={posting.id}
                    color="neutral_500"
                    fontSize={16}
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    • {posting.title}
                  </Text>
                ))}
              </Box>

              {hasMore && (
                <Box marginBottom={8} alignItems="flex-end" marginRight={8}>
                  <Pressable onPress={() => setShowAll(true)}>
                    <Text
                      color="secondary_500"
                      fontSize={16}
                      bold
                      style={{ textDecoration: 'underline' }}
                    >
                      View More
                    </Text>
                  </Pressable>
                </Box>
              )}
            </>
          ) : (
            <Box
              style={{
                maxHeight: 96,
                overflowY: 'auto',
              }}
              gap={4}
              paddingRight={8}
              marginBottom={8}
              width={420}
            >
              {suspendedPostings.map((posting) => (
                <Text
                  key={posting.id}
                  color="neutral_500"
                  fontSize={16}
                  style={{
                    overflow: 'clip',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  • {posting.title}
                </Text>
              ))}
            </Box>
          )}

          <Text color="neutral_500" fontSize={16} marginTop={16}>
            To reactivate them, click &quot;Pay Now&quot;. Once payment is confirmed, your jobs will
            reappear for professionals to view and apply.
          </Text>
        </Column>
      </Center>
    );
  };

  return (
    <>
      {isOpen && suspendedPostings.length > 0 && (
        //@ts-expect-error missing some props from ConfirmPopup
        <ConfirmPopup
          title="Action Needed: Unpaid Job Postings"
          description={renderDescription}
          Icon={WarningIconComponent}
          leftButtonText="Pay Later"
          rightButtonText="Pay Now"
          leftButtonAction={handlePayLater}
          rightButtonAction={handlePayNow}
          rightButtonLoading={isProcessing}
          rightButtonDisabled={isProcessing}
          closePopup={handlePayLater}
          dismissiblePopup={false}
          showClosePopupIcon={false}
          descriptionStyle={{
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      )}

      <PaymentSuccessPopup
        isOpen={paymentResultState === 'success'}
        onClose={handleCloseSuccessPopup}
      />

      <PaymentFailedPopup
        isOpen={paymentResultState === 'failed'}
        failedPostings={failedPostings}
        totalCount={failedPostings.length}
        onRetry={handleRetryFromFailedPopup}
        onPayLater={handlePayLaterFromFailedPopup}
      />
    </>
  );
};
